import { BaseSkin } from '../base/index';
import { bigPlayButtonCss } from '../default/bigPlayButton';
import { buttonOverrides } from '../default/buttonOverrides';

export class MovietimeSkin extends BaseSkin {
    get styleContents() {
        return `
          .vjs-volume-bar.vjs-slider-bar.vjs-slider.vjs-slider-vertical {
            margin: auto;
          }

          /*
          SASS VERSION CAN BE FOUND HERE:
          https://codepen.io/benjipott/pen/JELELN
          
          Player Skin Designer for Video.js
          http://videojs.com
        
          To customize the player skin edit 
          the CSS below. Click "details" 
          below to add comments or questions.
          This file uses some SCSS. Learn more  
          at http://sass-lang.com/guide)
        
          This designer can be linked to at:
          https://codepen.io/heff/pen/EarCt/left/?editors=010
        */
      
        @font-face {
            font-family: nf-icon;
          src: url(https://assets.nflxext.com/ffe/siteui/fonts/nf-icon-v1-86.eot);
          src: url(https://assets.nflxext.com/ffe/siteui/fonts/nf-icon-v1-86.eot?#iefix) format("embedded-opentype"), url(https://assets.nflxext.com/ffe/siteui/fonts/nf-icon-v1-86.woff) format("woff"), url(https://assets.nflxext.com/ffe/siteui/fonts/nf-icon-v1-86.ttf) format("truetype"), url(https://assets.nflxext.com/ffe/siteui/fonts/nf-icon-v1-86.svg#nf-icon-v1-86) format("svg");
          font-weight: 400;
          font-style: normal;
        }
        
        .video-js {
          /* The base font size controls the size of everything, not just text.
            All dimensions use em-based sizes so that the scale along with the font size.
            Try increasing it to 15px and see what happens. */
            font-size: 16px;
          /* The main font color changes the ICON COLORS as well as the text */
            color: #cacaca;
        }
        
        /* The "Big Play Button" is the play button that shows before the video plays.
          To center it set the align values to center and middle. The typical location
          of the button is the center, but there is trend towards moving it to a corner
          where it gets out of the way of valuable content in the poster image.*/
        .vjs-default-skin .vjs-big-play-button {
          /* The font size is what makes the big play button...big. 
            All width/height values use ems, which are a multiple of the font size.
            If the .video-js font-size is 10px, then 3em equals 30px.*/
            font-size: 4em;
          /* We're using SCSS vars here because the values are used in multiple places.
            Now that font size is set, the following em values will be a multiple of the
            new font size. If the font-size is 3em (30px), then setting any of
            the following values to 3em would equal 30px. 3 * font-size. */
          /* 1.5em = 45px default */
          line-height: 1.5em;
          height: 1.5em;
          width: 1.5em;
          /* 0.06666em = 2px default */
          border: 0.06666em solid rgba(38, 38, 38, 0.9);
          /* 0.3em = 9px default */
          border-radius: 50%;
          display: none;
          /* Align center */
          left: 50%;
          top: 40%;
          margin-left: -0.75em;
          margin-top: -0.75em; }
        
        .video-js .vjs-play-control,
        .video-js .vjs-remaining-time,
        .video-js .vjs-volume-menu-button {
          border-right: 1px solid #323232; }
        
        .video-js .vjs-volume-menu-button .vjs-menu-content:before {
          content: "";
          display: inline-block;
          vertical-align: middle;
          height: 100%; }
        
        .video-js .vjs-volume-menu-button .vjs-menu-content .vjs-volume-bar {
          display: inline-block;
          vertical-align: middle; }
        
        /* The default color of control backgrounds is mostly black but with a little
          bit of blue so it can still be seen on all-black video frames, which are common. */
        .video-js .vjs-control:before {
          font-family: nf-icon; }
        
              
        .video-js .vjs-control.vjs-volume-menu-button:before {
          content: "\e630"; }
        
        .video-js .vjs-control.vjs-captions-button:before {
          content: "\e650"; }
        
        .video-js .vjs-control-bar,
        .video-js .vjs-big-play-button,
        .video-js .vjs-menu-button .vjs-menu-content {
          /* IE8 - has no alpha support */
          background-color: #FFF;
          /* Opacity: 1.0 = 100%, 0.0 = 0% */
          background-color: rgba(255, 255, 255, 0); }

        .video-js .vjs-big-play-button {
          border-color: rgb(202, 202, 202);
        }
        
        .video-js .vjs-control-bar {
          background-color: rgba(38, 38, 38, 0.9);
          width: auto;
          left: 4em;
          right: 4em;
          bottom: 2em;
          border-radius: 0.5em; }
          .video-js .vjs-control-bar:hover .vjs-progress-control {
            opacity: 1;
            top: -2.4em; }
          .video-js .vjs-control-bar .vjs-menu {
            z-index: 2;
            height: 100%; }
        
        .video-js.vjs-fullscreen .vjs-control-bar {
          bottom: 4em; }
        
        .video-js .vjs-current-time {
          display: block;
          position: absolute;
          right: 0;
          top: -2.4em; }
        
        /* Slider - used for Volume bar and Progress bar */
        .video-js .vjs-slider {
          background-color: #2e2e2e;
          background-color: rgba(255, 255, 255, 0.3);
          border-radius: 1em;
          margin: 0; }
        
        .video-js .vjs-remaining-time {
          flex: 1;
          text-align: left; }
        
        /* The slider bar color is used for the progress bar and the volume bar
          (the first two can be removed after a fix that's coming) */
            .video-js .vjs-volume-level,
        .video-js .vjs-play-progress,
        .video-js .vjs-slider-bar {
          background: #cacaca;
            border-radius: 1em;
        }
        
        .video-js .vjs-play-progress {
            color: rgba(255,255,255,.9);
            background: rgba(255,255,255,.9);
            font-size: 1.3em;
        }
        
        .video-js .vjs-play-progress:before {
            transition: width 0.1s ease-out, height 0.1s ease-out;
            content: "";
            top: -0.2em;
            border: 0;
            background: radial-gradient(#2e2e2e 33%, #FFF);
            width: 1em;
            height: 1em;
            border-radius: 50%;
            box-shadow: #000 0 0 2px;
        }
        
        .video-js .vjs-play-progress:hover:before {
            width: 1.1em;
            height: 1.1em;
            border: 2px solid transparent;
        }
        
        .video-js .vjs-progress-control {
            position: absolute;
            left: 0;
            right: 0;
            width: 100%;
            padding: 0 4em 0 0.4em;
            top: -2.3em;
            border-radius: 1em;
            transition: top 150ms linear, opacity 150ms linear, transform 150ms linear, -webkit-transform 150ms linear, -moz-transform 150ms linear, -o-transform 150ms linear;
            z-index: 1;
            opacity: 0;
        }
        
        .video-js .vjs-progress-control:hover .vjs-progress-holder {
            font-size: inherit;
        }
        
        .video-js .vjs-progress-control .vjs-mouse-display {
            background: #cacaca;
        }
        
        .video-js .vjs-progress-control .vjs-mouse-display:before {
            display: none;
        }
        
        .video-js .vjs-time-tooltip {
            background: #cacaca !important;
            color: #2e2e2e;
        }
        
        .video-js .vjs-time-tooltip:before {
            top: 100%;
            border: solid transparent;
            content: " ";
            height: 0;
            width: 0;
            position: absolute;
            border-top-color: #262626;
            border-width: 0.8em;
            right: 25%;
            margin-left: -0.8em;
        }
        
        .video-js .vjs-play-progress,
        .video-js .vjs-load-progress {
            height: 0.7em !important;
        }
        
        .video-js .vjs-progress-holder {
            height: 0.9em;
        }
        
        /* The main progress bar also has a bar that shows how much has been loaded. */
        .video-js .vjs-load-progress {
          /* For IE8 we'll lighten the color */
          background: #3a3a3a;
          /* Otherwise we'll rely on stacked opacities */
            background: rgba(0, 0, 0, 0.1);
            border-radius: 1em;
            height: 0.9em !important;
        }
        
        /* The load progress bar also has internal divs that represent
          smaller disconnected loaded time ranges */
        .video-js .vjs-load-progress div {
          /* For IE8 we'll lighten the color */
          background: #3a3a3a;
          /* Otherwise we'll rely on stacked opacities */
            background: rgba(255, 255, 255, 0.7);
            border-radius: 1em;
            height: 0.9em !important;
        }
        
        .vjs-loading-spinner {
            border: none;
            opacity: 0;
            visibility: hidden;
            animation: vjs-spinner-fade-out 2s linear 1;
            animation-delay: 2s;
        }
        
        .vjs-loading-spinner:before, .vjs-loading-spinner:after {
            border: none;
        }
        
        .vjs-loading-spinner:after {
            background-image: url(https://assets.nflxext.com/en_us/pages/wiplayer/site-spinner.png);
            background-repeat: no-repeat;
            background-position-x: 50%;
            background-position-y: 50%;
            -moz-background-size: 100%;
            -o-background-size: 100%;
            background-size: 100%;
        }
        
        .vjs-seeking .vjs-loading-spinner:after,
        .vjs-waiting .vjs-loading-spinner:after {
            animation: vjs-spinner-spin 1.1s linear infinite, vjs-spinner-fade 1.1s linear 1 !important;
            animation-delay: 2s;
        }
        
        .vjs-seeking .vjs-loading-spinner,
        .vjs-waiting .vjs-loading-spinner {
            opacity: 1;
            visibility: visible;
            animation: vjs-spinner-fade-in 2s linear 1;
            animation-delay: 2s;
        }
        
        @keyframes vjs-spinner-fade-in {
            0% {
                opacity: 0;
                visibility: visible;
            }
        
            100% {
                opacity: 1;
                visibility: visible;
            }
        }
        
        @keyframes vjs-spinner-fade-out {
            0% {
                opacity: 1;
                visibility: visible;
            }
        
            100% {
                opacity: 0;
                visibility: visible;
            }
        }
      ` + bigPlayButtonCss;
    }

    get styleOverrideContents() {
      const { colors, buttons } = this.props.skinProps;
  
      if (!colors) {
          return '';
      }

      return `
        /* * * * * * * * * * * * * * * * * * * * * * * * * * * */
        /* * * * * * * * * *   Movie Time  * * * * * * * * * * */
    
        .vjs-default-skin.hy-controlbar-skin-movietime .vjs-control-bar {
          ${colors.background ? 'background-color: ' + colors.background : '' };
          ${colors.text ? 'color: ' + colors.text : '' };
        }
    
        .vjs-default-skin.hy-controlbar-skin-movietime .vjs-play-progress:before,
        .vjs-default-skin.hy-controlbar-skin-movietime .vjs-play-progress.vjs-slider-bar {
            ${colors.progressbar ? 'background: ' + colors.progressbar : '' };
        }
    
        .vjs-default-skin.hy-controlbar-skin-movietime .vjs-slider {
            background-color: rgba(255, 255, 255, 0.2);
        }
    
        .vjs-default-skin.hy-controlbar-skin-movietime .vjs-time-tooltip {
            ${colors.background ? 'background: ' + colors.background + ' !important' : '' };
            ${colors.text ? 'color: ' + colors.text : '' };
        }
    
        .vjs-default-skin.hy-controlbar-skin-movietime .vjs-time-tooltip:before {
            ${colors.background ? 'border-top-color: ' + colors.background + ' !important' : '' };
        }

        .video-js .vjs-remaining-time {
          visibility: hidden;
        }

        .vjs-default-skin.hy-controlbar-skin-movietime .vjs-big-play-button {
          ${buttons.showLargePlayButton === false ? 'display: none !important' : ''}
        }
      ` + buttonOverrides(buttons);
  }    
}
